<label class="label">
  <ng-content></ng-content>
  <input #fileInput multiple="true" type="file" (change)="fileChange($event)" [accept]="getSupportedFileTypes()" />
</label>
